import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import IrbApplicationModule from "@/store/modules/IrbApplicationModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import AdminModule from "@/store/modules/AdminModule";
import IrbGptModule from "@/store/modules/IrbGPTModule";
import IrbIssueModule from "@/store/modules/IrbIssuesModule";
import FacultyModule from "@/store/modules/FacultyModule";
import MemberModule from "@/store/modules/MemberModule";
import NotificationFormModule from "@/store/modules/NotificationFormModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    IrbApplicationModule,
    AdminModule,
    IrbGptModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    FacultyModule,
    MemberModule,
    NotificationFormModule,
    IrbIssueModule,
  },
});

export default store;
